module.exports = __webpack_public_path__ + "static/media/otp.6563ec9a.png";